import React, { useState, useEffect } from "react";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import LMEIGlobaleForm from "./DocTypes/LMEI/LMEIGlobaleForm";
import LMGSCTEForm from "./DocTypes/LMGSCTE/LMGSCTEForm.js";
import LMCREATIONForm from "./DocTypes/LMCREATION/LMCREATIONForm.js";
import LMSECRETARIATForm from "./DocTypes/LMSECRETARIAT/LMSECRETARIATForm.js";
import LMME from "./DocTypes/LMME/LMMEForm.js";
import "./SignModif.css";
import { useNavigate } from "react-router-dom";
import { useEtatGlobal, CABINETS_LM } from "../EtatGlobal.js";
import LMBNCForm from "./DocTypes/LMBNC/LMBNCForm.js";
import LMPREVForm from "./DocTypes/LMPREV/LMPREVForm.js";
import LMSocialForm from "./DocTypes/LMSOCIAL/LMSocialForm.js";
import { IoReload } from "react-icons/io5";
import { CiViewList } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import LMLogiciel from "./DocTypes/LMLOGICIEl/LMLogicielForm.js";
import LMSOCIALPONCTForm from "./DocTypes/LMSOCIALPONCT/LMSOCIALPONCTForm.js";
import LMEVALUATIONForm from "./DocTypes/LMEVALUATION/LMEVALUATIONForm.js";
import LMIRForm from "./DocTypes/LMIR/LMIRForm.js";
import LMSITUATIONForm from "./DocTypes/LMSITUATION/LMSITUATIONForm.js";
import LMBDCForm from "./DocTypes/LMBDC/LMBDCForm.js";
import LMBCRBEForm from "./DocTypes/LMBCRBE/LMBCRBEForm.js";
import LMAUDITForm from "./DocTypes/LMAUDIT/LMAUDITForm.js";
import { LM_AUDIT, donneesDocumentAudit } from "./DocTypes/LMAUDIT/auditDocument.js";
import { codePositionAudit } from "./DocTypes/LMAUDIT/auditSignature.js";
import LMLIBREForm from "./DocTypes/LMLIBRE/LMLIBREForm.js";
import { LM_LIBRE, LIBELLE_LM_LIBRE, donneesDocumentLibre, nomDocumentLibre } from "./DocTypes/LMLIBRE/lmLibreDocument.js";
import LetterSelect from "./letterSelect.js";
import ClientSearch from "./clientSearch.js";

import { LuSave } from "react-icons/lu";
import { IoAlertCircleOutline } from "react-icons/io5";
import { FileText, Calendar, X } from "lucide-react";
import { authFetch } from "../../HttpClient";
import { cleBrouillon } from "./lmBrouillon.js";

import { dialog } from "../../components/ui/Dialog";

const LOADING_STEPS = [
  {
    label: "Génération du document Word",
    sublabel: "Remplissage du template...",
  },
  { label: "Envoi vers le serveur", sublabel: "Transfert en cours..." },
  { label: "Conversion Word → PDF", sublabel: "Service de conversion..." },
  { label: "Sauvegarde du fichier", sublabel: "Stockage cloud..." },
  { label: "Préparation de l'affichage", sublabel: "Presque prêt..." },
];

function SignModif() {
  const navigate = useNavigate();

  const [shouldNavigate, setShouldNavigate] = useState(false);
  const [missingFields, setMissingFields] = useState(false);

  const [showLMAcheveOverlay, setShowLMAcheveOverlay] = React.useState(false);
  const [lmNonAcheves, setLmNonAcheves] = useState([]);
  const [isLoadingLmNonAcheves, setIsLoadingLmNonAcheves] = useState(false);

  const [selectedClientId, setSelectedClientId] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [detailsMission, setDetailsMission] = useState(null);
  const [detailsHonoraire, setDetailsHonoraire] = useState(null);

  const [onHonoraireChange] = useState(null);

  const [pdfUrl, setPdfUrl] = useState("");
  // const [formLeads, setFormLeads] = useState([]);

  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [loadingLMSaved, setLoadingLMSaved] = useState(false);
  const {
    formData,
    setFormData,
    nombreLignesTableau,
    nombreLignesTexteLibre,
    leadIdGlobal, // ✅ nouveau
    clientIdGlobal,
    brouillonLm,
    setBrouillonLm,
    setNombreLignesTableau,
    setNombreLignesTexteLibre,
    setCabinetRequisVisible,
  } = useEtatGlobal();

  console.log("FormData dans SignModif :", formData);

  console.log("Nombre de lignes du tableau :", nombreLignesTableau);

  const [selectedForm, setSelectedForm] = useState(
    formData.selectedForm || "LM Globale SCTE.docx"
  );
  const [isLoading, setIsLoading] = useState(false);
  const [loadingStepIdx, setLoadingStepIdx] = useState(-1);
  let display = "false";

  console.log("----- id lead :", leadIdGlobal);

  useEffect(() => {
    const leadIdFinal =
      leadIdGlobal && leadIdGlobal !== "" ? leadIdGlobal : selectedLeadId;
    const clientIdFinal =
      clientIdGlobal && clientIdGlobal !== "" ? clientIdGlobal : selectedClientId;

    console.log("----- id lead Final :", leadIdFinal);
    console.log("----- Client id", clientIdFinal);

    if (!pdfUrl) return;

    const visuelState = {
      pdfUrl,
      nom_client: formData.nom_client,
      email: formData.email,
      comptable: formData.expert_comptable,
      civilite_lm: formData.civilite_lm,
      nom: formData.nom,
      prenom: formData.prenom,
      telephone: formData.telephone,
      siren: formData.siren,
      selectedForm,
      display: false,
      leadId: leadIdFinal,
      clientId: clientIdFinal,
      nombreLignesTableau,
      nombreLignesTexteLibre,
      formeSociale: formData.forme_sociale,
      societeNom: formData.nom_client,
      avenant: formData.avenant,
    };

    if (shouldNavigate) {
      console.log("---- DONNÉES ENVOYÉES À VISUEL ----", visuelState);

      navigate("/Visuel", {
        state: visuelState,
      });
      setShouldNavigate(false);
    } else {
      console.log(
        "---- DONNÉES POUR SOUMISSION LM (SANS NAVIGATION) ----",
        visuelState
      );
    }
  }, [
    pdfUrl,
    shouldNavigate,
    formData,
    navigate,
    selectedForm,
    selectedLeadId,
    nombreLignesTableau,
    nombreLignesTexteLibre,
    leadIdGlobal,
    clientIdGlobal,
    selectedClientId,
  ]);

  // useEffect(() => {
  //   authFetch("https://backend-myalfa.vercel.app/api/formleads")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setFormLeads(data.data || []);
  //     })
  //     .catch((error) => {
  //       console.error("Erreur lors du chargement des leads :", error);
  //     });
  // }, []);

  // const handleLeadSelect = (e) => {
  //   const selectedId = parseInt(e.target.value);
  //   const selectedLead = formLeads.find((lead) => lead.id === selectedId);

  //   if (selectedLead) {
  //     setSelectedLeadId(selectedLead.id); // <-- Ajout
  //     setFormData((prev) => ({
  //       ...prev,
  //       nom_client: selectedLead.societeNom || " ",
  //       nom: selectedLead.nom || " ",
  //       prenom: selectedLead.prenom || " ",
  //       civilite_lm: selectedLead.civilite === "M." ? "Monsieur" : "Madame",
  //       email: selectedLead.mail || " ",
  //       telephone: selectedLead.tel || " ",
  //       adresse: selectedLead.adresse || " ",
  //       siren: selectedLead.sirenSociete || " ",
  //       siret: selectedLead.sirenSociete || " ",
  //       forme_sociale: selectedLead.formeSociale || "EI",
  //     }));
  //   }
  // };

  console.log(display);

  const handleDateClotureChange = (event) => {
    const { name, value } = event.target;
    const updatedFormData = {
      ...formData,
      [name]: value,
      date_cloture: `${formData.date_cloture_jour}/${formData.date_cloture_mois}`,
    };
    updatedFormData.date_cloture = `${updatedFormData.date_cloture_jour}/${updatedFormData.date_cloture_mois}`;
    setFormData(updatedFormData);
  };

  const handleResetFormData = () => {
    setFormData((prev) => ({
      ...prev,
      nom: " ",
      prenom: " ",
      civilite_lm: "Monsieur",
      forme_sociale: "EI",
      email: " ",
      telephone: " ",
      adresse: " ",
      siren: " ",
      siret: " ",
      nom_client: " ",
      // Valeurs par défaut fixes (options de liste connues) pour que les
      // champs passés en mode "Autre" (SelectOuAutre.js) redeviennent des
      // select au lieu de rester bloqués en input libre après reset.
      effectif: "0",
      organisation_comptable: "Sous-traitance",
      type_evaluation: "vos droits sociaux",
      // LM Audit d'acquisition
      type_remuneration: "fixe",
      motifs_reprise: "",
      secteur_activite: "",
      cible_acquisition: "",
      prix_achat: "",
      modalite_financement: "",
      calendrier_acquisition: "",
      montant_fixe: "",
      taux_honoraires: "",
      montant_minimum: "",
      audit_lignes_exclues: [],
      // LM libre – autres prestations
      nom_mission: "",
      description_mission: "",
      livrable: "",
      descriptif_mission: "",
      autres_informations: "",
      libre_travaux: [""],
      libre_exclusions: [""],
      libre_honoraires: [{ libelle: "", montant: "" }],
    }));
    setSelectedForm(" ");
    setSelectedLeadId(null); // Réinitialise aussi le client sélectionné si nécessaire
    setBrouillonLm(null); // nouvelle LM : le prochain enregistrement crée un nouveau brouillon
  };

  const handleSaveLM = async () => {
    if (loadingLMSaved) return;
    // La sélection du cabinet est obligatoire même pour un brouillon
    if (!formData.lieu_collab || formData.lieu_collab.trim() === "") {
      setCabinetRequisVisible(true);
      dialog.alert(
        "Veuillez remplir les champs suivants :\nSélection du cabinet"
      );
      return;
    }
    setCabinetRequisVisible(false);
    setLoadingLMSaved(true);
    const {
      tarif,
      details_tarif,
      details_tarif_prix,
      details_tarif_prix_tva,
      details_tarif_prix_total,
      tva_taux,
      tva_taux_libelle,
      //
      diligences,
      honoraires,
      abrv,
      selectedForm,
      forme_sociale,
      nom_client,
      date_jour,
      mission_proposer,
      lieu_collab,
      civilite_lm,
      civilite_sign,
      nom,
      prenom,
      email,
      telephone,
      adresse,
      siren,
      siret,
      acticite_principale,
      date_cloture_jour,
      date_cloture_mois,
      date_cloture,
      effectif,
      organisation_comptable,
      volumes_annuels,
      mission_comptables,
      mission_sociale,
      mission_juridique,
      date_creation,
      date_debut,
      date_fin,
      premiere_dsn_raw,
      premiere_dsn,
      premier_tri_dsn,
      premier_tri_dsn_raw,
      expert_comptable,
      expert_comptable_nom,
      hono_compta,
      hono_compta_bnc,
      hono_compta_me,
      hono_juridique,
      hono_social,
      hono_tele,
      mission_complementaire,
      mois_intervention,
      total_honoraires,
      TVA_honoraires_pourcentage,
      TVA_honoraires,
      total_honoraires_ttc,
      type_evaluation,
      details_type_evaluation,
      champ_libre,
      texteFin,
      declaration_ir,
      declaration_tns,
      declaration_ds,
      declaration_ifi,
      pr_annee,
      hono_ir,
      hono_ir_12,
      avenant,
      numero_avenant,
      date_avenant,
      textAvenant,
      // Pied de page juridique du cabinet sélectionné (CabinetSelect.js) —
      // sans ça, recharger ce brouillon restaure lieu_collab mais génère un
      // LM au pied de page vide.
      denomination_cab,
      forme_cab,
      capital_cab,
      siege_cab,
      siren_cab,
      siret_cab,
      ville_rcs_cab,
      // LM Audit d'acquisition
      type_remuneration,
      motifs_reprise,
      secteur_activite,
      cible_acquisition,
      prix_achat,
      modalite_financement,
      calendrier_acquisition,
      montant_fixe,
      taux_honoraires,
      montant_minimum,
      audit_lignes_exclues,
      // LM libre – autres prestations
      nom_mission,
      description_mission,
      livrable,
      descriptif_mission,
      autres_informations,
      libre_travaux,
      libre_exclusions,
      libre_honoraires,
    } = formData;

    const isValid = (val) => typeof val === "string" && val.trim() !== "";

    const isFormDataComplete =
      isValid(selectedForm) &&
      isValid(civilite_lm) &&
      isValid(nom) &&
      isValid(prenom) &&
      isValid(email) &&
      isValid(telephone);

    if (!isFormDataComplete) {
      setLoadingLMSaved(false); // sinon le bouton restait bloqué en chargement
      dialog.alert("Merci de remplir tous les champs avant de sauvegarder.");
      return;
    }

    const currentData = {
      itemType: itemType,

      tarif: tarif || "",
      details_tarif: details_tarif || "",
      details_tarif_prix: details_tarif_prix || "",
      details_tarif_prix_tva: details_tarif_prix_tva || "",
      details_tarif_prix_total: details_tarif_prix_total || "",
      tva_taux: tva_taux ?? "",
      tva_taux_libelle: tva_taux_libelle || "",
      //
      diligences: diligences || "",
      honoraires: honoraires || "",
      abrv: abrv || "",
      selectedForm: selectedForm || "",
      forme_sociale: forme_sociale || "",
      nom_client: nom_client || "",
      date_jour: date_jour || "",
      mission_proposer: mission_proposer || "",
      lieu_collab: lieu_collab || "",
      civilite_lm: civilite_lm || "",
      civilite_sign: civilite_sign || "",
      nom: nom || "",
      prenom: prenom || "",
      email: email || "",
      telephone: telephone || "",
      adresse: adresse || "",
      siren: siren || "",
      siret: siret || "",
      acticite_principale: acticite_principale || "",
      date_cloture_jour: date_cloture_jour || "",
      date_cloture_mois: date_cloture_mois || "",
      date_cloture: date_cloture || "",
      effectif: effectif || "",
      organisation_comptable: organisation_comptable || "",
      volumes_annuels: volumes_annuels || "",
      mission_comptables: mission_comptables || "",
      mission_sociale: mission_sociale || "",
      mission_juridique: mission_juridique || "",
      date_creation: date_creation || "",
      date_debut: date_debut || "",
      date_fin: date_fin || "",
      premiere_dsn_raw: premiere_dsn_raw || "",
      premiere_dsn: premiere_dsn || "",
      premier_tri_dsn: premier_tri_dsn || "",
      premier_tri_dsn_raw: premier_tri_dsn_raw || "",
      expert_comptable: expert_comptable || "",
      expert_comptable_nom: expert_comptable_nom || "",
      hono_compta: hono_compta || "",
      hono_compta_bnc: hono_compta_bnc || "",
      hono_compta_me: hono_compta_me || "",
      hono_juridique: hono_juridique || "",
      hono_social: hono_social || "",
      hono_tele: hono_tele || "",
      mission_complementaire: mission_complementaire || "",
      mois_intervention: mois_intervention || "",
      total_honoraires: total_honoraires || "",
      TVA_honoraires_pourcentage: TVA_honoraires_pourcentage || "",
      TVA_honoraires: TVA_honoraires || "",
      total_honoraires_ttc: total_honoraires_ttc || "",
      type_evaluation: type_evaluation || "",
      details_type_evaluation: details_type_evaluation || "",
      champ_libre: champ_libre || "",
      texteFin: texteFin || "",
      declaration_ir: declaration_ir || "",
      declaration_tns: declaration_tns || "",
      declaration_ds: declaration_ds || "",
      declaration_ifi: declaration_ifi || "",
      pr_annee: pr_annee || "",
      hono_ir: hono_ir || "",
      hono_ir_12: hono_ir_12 || "",
      avenant: avenant || "",
      numero_avenant: numero_avenant || "",
      date_avenant: date_avenant || "",
      textAvenant: textAvenant || "",
      denomination_cab: denomination_cab || "",
      forme_cab: forme_cab || "",
      capital_cab: capital_cab || "",
      siege_cab: siege_cab || "",
      siren_cab: siren_cab || "",
      siret_cab: siret_cab || "",
      ville_rcs_cab: ville_rcs_cab || "",
      // LM Audit d'acquisition (lignes décochées du §2.2 en JSON)
      type_remuneration: type_remuneration || "",
      motifs_reprise: motifs_reprise || "",
      secteur_activite: secteur_activite || "",
      cible_acquisition: cible_acquisition || "",
      prix_achat: prix_achat || "",
      modalite_financement: modalite_financement || "",
      calendrier_acquisition: calendrier_acquisition || "",
      montant_fixe: montant_fixe || "",
      taux_honoraires: taux_honoraires || "",
      montant_minimum: montant_minimum || "",
      audit_lignes_exclues: Array.isArray(audit_lignes_exclues)
        ? JSON.stringify(audit_lignes_exclues)
        : audit_lignes_exclues || "",
      // LM libre – autres prestations (listes en JSON, comme le §2.2 de l'audit)
      nom_mission: nom_mission || "",
      description_mission: description_mission || "",
      livrable: livrable || "",
      descriptif_mission: descriptif_mission || "",
      autres_informations: autres_informations || "",
      libre_travaux: Array.isArray(libre_travaux) ? JSON.stringify(libre_travaux) : libre_travaux || "",
      libre_exclusions: Array.isArray(libre_exclusions) ? JSON.stringify(libre_exclusions) : libre_exclusions || "",
      libre_honoraires: Array.isArray(libre_honoraires) ? JSON.stringify(libre_honoraires) : libre_honoraires || "",
      //
    };

    // Sauvegarde locale (optionnelle)
    sessionStorage.setItem("lastSavedForm", JSON.stringify(currentData));

    try {
      // Brouillon déjà créé ou repris pour cette même LM → mise à jour (PUT)
      // plutôt qu'une nouvelle ligne à chaque enregistrement. S'il a été
      // supprimé entre-temps (404), on en recrée un.
      const cle = cleBrouillon({ nom_client, nom, prenom, selectedForm });
      const brouillonId = brouillonLm?.cle === cle ? brouillonLm.id : null;
      const envoyer = (url, method) =>
        authFetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(currentData),
        });
      const BROUILLON_URL = "https://backend-myalfa.vercel.app/api/lmnonacheve";

      let response = brouillonId
        ? await envoyer(`${BROUILLON_URL}/${brouillonId}`, "PUT")
        : null;
      const misAJour = !!response?.ok;
      if (!response || response.status === 404) {
        response = await envoyer(BROUILLON_URL, "POST");
      }

      if (!response.ok) {
        throw new Error("Erreur lors de la sauvegarde");
      }

      const sauvegarde = await response.json();
      // La référence de la LM naît au premier enregistrement du brouillon et
      // reste la même ensuite (renvoyée par le backend).
      setBrouillonLm({ id: sauvegarde.id, cle, reference: sauvegarde.reference });

      console.log("Formulaire sauvegardé avec succès");
      dialog.alert(misAJour ? "Brouillon mis à jour !" : "Formulaire sauvegardé !");
    } catch (error) {
      console.error("Erreur:", error);
      dialog.alert("Une erreur est survenue lors de la sauvegarde.");
    } finally {
      setLoadingLMSaved(false); // ✅ fin loading (succès ou erreur)
    }
  };

  // --- Recherche client --

  console.log(" ########## Client sélectionné ID :", selectedClientId);

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    const moisFR = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];

    // 🔹 petite fonction pour calculer les lignes
    const calculerNombreLignes = (texte) => {
      if (!texte) return 1;

      // Compte aussi les retours à la ligne manuels
      const lignesParLongueur = Math.ceil(texte.length / 95);
      const lignesParSaut = texte.split(/\n/).length;
      return Math.max(lignesParLongueur, lignesParSaut);
    };

    if (
      name === "date_debut" ||
      name === "date_fin" ||
      name === "date_creation" ||
      name === "date_avenant"
    ) {
      const [year, month, day] = value.split("-");
      const formattedDate = `${day}/${month}/${year}`;
      setFormData((prev) => ({ ...prev, [name]: formattedDate }));
    } else if (name === "premiere_dsn_raw" || name === "premier_tri_dsn_raw") {
      const [year, month] = value.split("-");
      const formatted = `${moisFR[parseInt(month, 10) - 1]} ${year}`;
      const fieldName = name.replace("_raw", "");
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        [fieldName]: formatted,
      }));
    } else if (name === "champ_libre") {
      const texteFixe =
        "Cette lettre reste en vigueur pour les exercices futurs, sauf en cas de résiliation, " +
        "de modification ou d'annulation de notre mission selon les modalités décrites dans les conditions générales et financières jointes.";

      const champ = value ?? "";

      // Vérifie si vide (ou juste espaces)
      const estVide = champ === "" || champ === " " || /^\s+$/.test(champ);

      // LM Création de société ne veut pas de cette phrase fixe accolée au
      // texte libre — seul le texte saisi doit apparaître (un espace si
      // vide, pour éviter le "[MANQUANT]" du template).
      const texteFinal =
        selectedForm === "LM Création de société.docx"
          ? estVide
            ? " "
            : champ
          : estVide
          ? texteFixe
          : `${champ}\n\n${texteFixe}`;

      setFormData((prev) => ({
        ...prev,
        [name]: value,
        texteFinal,
      }));

      // 🔹 Calcul dynamique du nombre de lignes du champ libre — écrit à la
      // fois dans nombreLignesTableau (comportement historique, utilisé par
      // LM Globale SCTE) et dans nombreLignesTexteLibre (dédié, utilisé par
      // LM Création de société pour ne pas entrer en conflit avec le
      // compteur du tableau d'honoraires de ce document).
      const lignes = calculerNombreLignes(champ);
      setNombreLignesTableau(lignes);
      setNombreLignesTexteLibre(estVide ? 0 : lignes);
    } else {
      setFormData((prev) => {
        const nouvelleCivilite =
          name === "civilite_lm" ? value : prev.civilite_lm;

        // 🔹 Quelle est la mission sélectionnée après le changement ?
        const mission =
          name === "mission_proposer" ? value : prev.mission_proposer;

        let miseAJourSpeciale = {};

        if (mission === "Révision") {
          // Si Révision → valeurs spécifiques
          miseAJourSpeciale = {
            // tableau annexe 2
            odlc_pa2: ["M"],
            odlc_cac_a2: " ",
            odlc_clc_a2: "X",
            odlc_aic_a2: " ",
            //
            tdf_pa2: ["A"],
            tdf_cac_a2: "X",
            tdf_clc_a2: " ",
            tdf_aic_a2: " ",
            //
            sip_pa2: ["A"],
            svdp_pa2: ["A"],
            sip_cac_a2: " ",
            svdp_cac_a2: " ",
            sip_clc_a2: "X",
            svdp_clc_a2: "X",
            sip_aic_a2: " ",
            svdp_aic_a2: " ",
            //
            jdc_pa2: ["A"],
            jdc_cac_a2: "X",
            jdc_clc_a2: " ",
            jdc_aic_a2: " ",
            //
            cdt_pa2: ["A"],
            cdt_cac_a2: "X",
            cdt_clc_a2: " ",
            cdt_aic_a2: " ",
            //
            cedc_pa2: ["A"],
            cedc_cac_a2: "X",
            cedc_clc_a2: " ",
            cedc_aic_a2: " ",
            //
            cps_pa2: ["A"],
            cps_cac_a2: "X",
            cps_clc_a2: " ",
            cps_aic_a2: " ",
            //
            jds_pa2: ["A"],
            jds_cac_a2: "X",
            jds_clc_a2: " ",
            jds_aic_a2: " ",
            //
            ecdc_pa2: ["A"],
            ecdc_cac_a2: "X",
            ecdc_clc_a2: " ",
            ecdc_aic_a2: " ",
            //
            edca_pa2: ["A"],
            edca_cac_a2: "X",
            edca_clc_a2: " ",
            edca_aic_a2: " ",
            //
            tdrl_pa2: ["A"],
            tdrl_cac_a2: "X",
            tdrl_clc_a2: " ",
            tdrl_aic_a2: " ",
            //
            dce_pa2: ["A"],
            dca_pa2: ["A"],
            dce_cac_a2: "X",
            dca_cac_a2: " ",
            dce_clc_a2: " ",
            dca_clc_a2: "X",
            dce_aic_a2: " ",
            dca_aic_a2: " ",
            //
            eem_pa2: ["P"],
            eem_cac_a2: " ",
            eem_clc_a2: "X",
            eem_aic_a2: " ",
            //
            cdp_pa2: ["M"],
            cdp_cac_a2: " ",
            cdp_clc_a2: "X",
            cdp_aic_a2: " ",
            //
            edlc_pa2: ["M", "T", "A"],
            edlco_pa2: [],
            edlc_cac_a2: " ",
            edlco_cac_a2: " ",
            edlc_clc_a2: "X",
            edlco_clc_a2: " ",
            edlc_aic_a2: " ",
            edlco_aic_a2: " ",
            //
            ededr_pa2: ["M", "T", "A"],
            ededr_cac_a2: " ",
            ededr_clc_a2: "X",
            ededr_aic_a2: " ",
            //
            ctdd_pa2: ["J"],
            csdo_pa2: [],
            ctdd_cac_a2: " ",
            csdo_cac_a2: " ",
            ctdd_clc_a2: "X",
            csdo_clc_a2: " ",
            ctdd_aic_a2: " ",
            csdo_aic_a2: " ",
            //
            adf_pa2: ["A"],
            adf_cac_a2: " ",
            adf_clc_a2: "X",
            adf_aic_a2: " ",
            //
            cdfdc_pa2: ["A"],
            cdfdc_cac_a2: "X",
            cdfdc_clc_a2: " ",
            cdfdc_aic_a2: " ",
            //
            cdfde_pa2: ["A"],
            cdfde_cac_a2: "X",
            cdfde_clc_a2: " ",
            cdfde_aic_a2: " ",
            //
            adfec_pa2: ["A"],
            adfec_cac_a2: "X",
            adfec_clc_a2: " ",
            adfec_aic_a2: " ",
            //
            eddr_pa2: ["A"],
            eddr_cac_a2: "X",
            eddr_clc_a2: " ",
            eddr_aic_a2: " ",
            //
            edcoa_pa2: ["N", "A"],
            edcoa_cac_a2: " ",
            edcoa_clc_a2: " ",
            edcoa_aic_a2: " ",
            //
            edddt_pa2: ["M"],
            edddt_cac_a2: " ",
            edddt_clc_a2: "X",
            edddt_aic_a2: " ",
            //
            eddddb_pa2: ["N", "A"],
            eddddb_cac_a2: " ",
            eddddb_clc_a2: " ",
            eddddb_aic_a2: " ",
            //
            dlas_pa2: ["N", "A"],
            dlas_cac_a2: "X",
            dlas_clc_a2: " ",
            dlas_aic_a2: " ",
            tsrlv_pa2: ["A"],
            tsrlv_cac_a2: "X",
            tsrlv_clc_a2: " ",
            tsrlv_aic_a2: " ",
            ddcdp_pa2: ["A"],
            ddcdp_cac_a2: " ",
            ddcdp_clc_a2: "X",
            ddcdp_aic_a2: " ",
            das_pa2: [],
            das_cac_a2: " ",
            das_clc_a2: " ",
            das_aic_a2: " ",
            //
            cfe_pa2: ["A"],
            cfe_cac_a2: " ",
            cfe_clc_a2: "X",
            cfe_aic_a2: " ",
            //
            cvae_pa2: ["A"],
            cvae_cac_a2: "X",
            cvae_clc_a2: " ",
            cvae_aic_a2: " ",
            //
            is_pa2: ["T", "A"],
            is_cac_a2: "X",
            is_clc_a2: " ",
            is_aic_a2: " ",
          };
        } else if (mission === "Tenue") {
          // Si Tenue → remettre les valeurs par défaut
          miseAJourSpeciale = {
            // tableau annexe 2
            odlc_pa2: ["M"],
            odlc_cac_a2: "X",
            odlc_clc_a2: "X",
            odlc_aic_a2: " ",
            //
            tdf_pa2: ["A"],
            tdf_cac_a2: "X",
            tdf_clc_a2: " ",
            tdf_aic_a2: " ",
            //
            sip_pa2: ["A"],
            svdp_pa2: ["A"],
            sip_cac_a2: " ",
            svdp_cac_a2: " ",
            sip_clc_a2: "X",
            svdp_clc_a2: "X",
            sip_aic_a2: " ",
            svdp_aic_a2: " ",
            //
            jdc_pa2: ["A"],
            jdc_cac_a2: "X",
            jdc_clc_a2: "X",
            jdc_aic_a2: " ",
            //
            cdt_pa2: ["A"],
            cdt_cac_a2: "X",
            cdt_clc_a2: " ",
            cdt_aic_a2: " ",
            //
            cedc_pa2: ["A"],
            cedc_cac_a2: "X",
            cedc_clc_a2: " ",
            cedc_aic_a2: " ",
            //
            cps_pa2: ["A"],
            cps_cac_a2: "X",
            cps_clc_a2: " ",
            cps_aic_a2: " ",
            //
            jds_pa2: ["A"],
            jds_cac_a2: "X",
            jds_clc_a2: " ",
            jds_aic_a2: " ",
            //
            ecdc_pa2: ["A"],
            ecdc_cac_a2: "X",
            ecdc_clc_a2: " ",
            ecdc_aic_a2: " ",
            //
            edca_pa2: ["A"],
            edca_cac_a2: "X",
            edca_clc_a2: " ",
            edca_aic_a2: " ",
            //
            tdrl_pa2: ["A"],
            tdrl_cac_a2: "X",
            tdrl_clc_a2: " ",
            tdrl_aic_a2: " ",
            //
            dce_pa2: ["A"],
            dca_pa2: ["A"],
            dce_cac_a2: "X",
            dca_cac_a2: " ",
            dce_clc_a2: " ",
            dca_clc_a2: "X",
            dce_aic_a2: " ",
            dca_aic_a2: " ",
            //
            eem_pa2: ["P"],
            eem_cac_a2: "X",
            eem_clc_a2: " ",
            eem_aic_a2: " ",
            //
            cdp_pa2: ["M"],
            cdp_cac_a2: "X",
            cdp_clc_a2: " ",
            cdp_aic_a2: " ",
            //
            edlc_pa2: ["M", "T", "A"],
            edlco_pa2: [],
            edlc_cac_a2: " ",
            edlco_cac_a2: "X",
            edlc_clc_a2: " ",
            edlco_clc_a2: " ",
            edlc_aic_a2: " ",
            edlco_aic_a2: " ",
            //
            ededr_pa2: ["M", "T", "A"],
            ededr_cac_a2: "X",
            ededr_clc_a2: " ",
            ededr_aic_a2: " ",
            //
            ctdd_pa2: ["J"],
            csdo_pa2: [],
            ctdd_cac_a2: " ",
            csdo_cac_a2: " ",
            ctdd_clc_a2: "X",
            csdo_clc_a2: "X",
            ctdd_aic_a2: " ",
            csdo_aic_a2: " ",
            //
            adf_pa2: ["A"],
            adf_cac_a2: "X",
            adf_clc_a2: " ",
            adf_aic_a2: " ",
            //
            cdfdc_pa2: ["A"],
            cdfdc_cac_a2: "X",
            cdfdc_clc_a2: " ",
            cdfdc_aic_a2: " ",
            //
            cdfde_pa2: ["A"],
            cdfde_cac_a2: "X",
            cdfde_clc_a2: " ",
            cdfde_aic_a2: " ",
            //
            adfec_pa2: ["A"],
            adfec_cac_a2: "X",
            adfec_clc_a2: " ",
            adfec_aic_a2: " ",
            //
            eddr_pa2: ["A"],
            eddr_cac_a2: "X",
            eddr_clc_a2: " ",
            eddr_aic_a2: " ",
            //
            edcoa_pa2: ["A"],
            edcoa_cac_a2: "X",
            edcoa_clc_a2: " ",
            edcoa_aic_a2: " ",
            //
            edddt_pa2: ["ND", "A"],
            edddt_cac_a2: "X",
            edddt_clc_a2: " ",
            edddt_aic_a2: " ",
            //
            eddddb_pa2: ["A"],
            eddddb_cac_a2: " ",
            eddddb_clc_a2: "X",
            eddddb_aic_a2: " ",
            //
            dlas_pa2: ["ND", "A"],
            dlas_cac_a2: "X",
            dlas_clc_a2: " ",
            dlas_aic_a2: " ",
            tsrlv_pa2: ["A"],
            tsrlv_cac_a2: "X",
            tsrlv_clc_a2: " ",
            tsrlv_aic_a2: " ",
            ddcdp_pa2: ["A"],
            ddcdp_cac_a2: " ",
            ddcdp_clc_a2: "X",
            ddcdp_aic_a2: " ",
            das_pa2: ["A"],
            das_cac_a2: "X",
            das_clc_a2: " ",
            das_aic_a2: " ",
            //
            cfe_pa2: ["A"],
            cfe_cac_a2: "X",
            cfe_clc_a2: " ",
            cfe_aic_a2: " ",
            //
            cvae_pa2: ["A"],
            cvae_cac_a2: "X",
            cvae_clc_a2: " ",
            cvae_aic_a2: " ",
            //
            is_pa2: ["ND", "A"],
            is_cac_a2: "X",
            is_clc_a2: " ",
            is_aic_a2: " ",
          };
        }

        return {
          ...prev,
          [name]: value,
          civilite_sign:
            nouvelleCivilite === "Monsieur" ? "Le client" : "La cliente",
          ...miseAJourSpeciale,
        };
      });
    }
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormData({
      ...formData,
      [name]: checked ? "☒" : "☐",
    });
  };

  const handleCheckboxChangeTabeleau = (event) => {
    const { name, checked } = event.target;
    setFormData({
      ...formData,
      [name]: checked ? "X" : " ",
    });
  };

  const handleCheckboxChangeDevis = (event) => {
    const { name, checked } = event.target;
    setFormData({
      ...formData,
      [name]: checked ? "Sur devis" : " ",
    });
  };

  const handleFormChange = (event) => {
    const newForm = event.target.value;
    setSelectedForm(newForm);
    setFormData((prevData) => ({
      ...prevData,
      selectedForm: newForm,
    }));
  };

  const handleHonoChange = (e) => {
    const { name, value } = e.target;

    // Enlever les caractères non numériques sauf la virgule
    let numericValue = value.replace(/[^0-9,]/g, "");

    // Remplacer la virgule par un point pour les calculs
    numericValue = numericValue.replace(",", ".");

    // Ajouter ",00" si aucune décimale
    if (numericValue && !numericValue.includes(".")) {
      numericValue += ",00";
    }

    // Ajouter l'€ à la fin si ce n'est pas déjà présent
    if (numericValue && !numericValue.endsWith(" €")) {
      numericValue += " €";
    }

    // Mettre à jour l'état avec la nouvelle valeur formatée
    setFormData({
      ...formData,
      [name]: numericValue,
    });
  };

  const ACTIONS = {
    VISUALISE: "VISUALISE",
    SUBMIT: "SUBMIT",
  };

  const generateDocument = async (action) => {
    if (action === ACTIONS.VISUALISE) {
      setIsLoading(true);
      setLoadingStepIdx(0);
    }

    try {
      const updatedFormData = {
        ...formData,
        odlc_pa2: Array.isArray(formData.odlc_pa2)
          ? formData.odlc_pa2.join("/")
          : "",
        tdf_pa2: Array.isArray(formData.tdf_pa2)
          ? formData.tdf_pa2.join("/")
          : "",
        sip_pa2: Array.isArray(formData.sip_pa2)
          ? formData.sip_pa2.join("/")
          : "",
        svdp_pa2: Array.isArray(formData.svdp_pa2)
          ? formData.svdp_pa2.join("/")
          : "",
        jdc_pa2: Array.isArray(formData.jdc_pa2)
          ? formData.jdc_pa2.join("/")
          : "",
        cdt_pa2: Array.isArray(formData.cdt_pa2)
          ? formData.cdt_pa2.join("/")
          : "",
        cedc_pa2: Array.isArray(formData.cedc_pa2)
          ? formData.cedc_pa2.join("/")
          : "",
        cps_pa2: Array.isArray(formData.cps_pa2)
          ? formData.cps_pa2.join("/")
          : "",
        jds_pa2: Array.isArray(formData.jds_pa2)
          ? formData.jds_pa2.join("/")
          : "",
        ecdc_pa2: Array.isArray(formData.ecdc_pa2)
          ? formData.ecdc_pa2.join("/")
          : "",
        edca_pa2: Array.isArray(formData.edca_pa2)
          ? formData.edca_pa2.join("/")
          : "",
        tdrl_pa2: Array.isArray(formData.tdrl_pa2)
          ? formData.tdrl_pa2.join("/")
          : "",
        dce_pa2: Array.isArray(formData.dce_pa2)
          ? formData.dce_pa2.join("/")
          : "",
        dca_pa2: Array.isArray(formData.dca_pa2)
          ? formData.dca_pa2.join("/")
          : "",
        eem_pa2: Array.isArray(formData.eem_pa2)
          ? formData.eem_pa2.join("/")
          : "",
        cdp_pa2: Array.isArray(formData.cdp_pa2)
          ? formData.cdp_pa2.join("/")
          : "",
        edlc_pa2: Array.isArray(formData.edlc_pa2)
          ? formData.edlc_pa2.join("/")
          : "",
        edlco_pa2: Array.isArray(formData.edlco_pa2)
          ? formData.edlco_pa2.join("/")
          : "",
        ededr_pa2: Array.isArray(formData.ededr_pa2)
          ? formData.ededr_pa2.join("/")
          : "",
        ctdd_pa2: Array.isArray(formData.ctdd_pa2)
          ? formData.ctdd_pa2.join("/")
          : "",
        csdo_pa2: Array.isArray(formData.csdo_pa2)
          ? formData.csdo_pa2.join("/")
          : "",
        adf_pa2: Array.isArray(formData.adf_pa2)
          ? formData.adf_pa2.join("/")
          : "",
        cdfdc_pa2: Array.isArray(formData.cdfdc_pa2)
          ? formData.cdfdc_pa2.join("/")
          : "",
        cdfde_pa2: Array.isArray(formData.cdfde_pa2)
          ? formData.cdfde_pa2.join("/")
          : "",
        adfec_pa2: Array.isArray(formData.adfec_pa2)
          ? formData.adfec_pa2.join("/")
          : "",
        eddr_pa2: Array.isArray(formData.eddr_pa2)
          ? formData.eddr_pa2.join("/")
          : "",
        edcoa_pa2: Array.isArray(formData.edcoa_pa2)
          ? formData.edcoa_pa2.join("/")
          : "",
        edddt_pa2: Array.isArray(formData.edddt_pa2)
          ? formData.edddt_pa2.join("/")
          : "",
        eddddb_pa2: Array.isArray(formData.eddddb_pa2)
          ? formData.eddddb_pa2.join("/")
          : "",
        dlas_pa2: Array.isArray(formData.dlas_pa2)
          ? formData.dlas_pa2.join("/")
          : "",
        tsrlv_pa2: Array.isArray(formData.tsrlv_pa2)
          ? formData.tsrlv_pa2.join("/")
          : "",
        ddcdp_pa2: Array.isArray(formData.ddcdp_pa2)
          ? formData.ddcdp_pa2.join("/")
          : "",
        das_pa2: Array.isArray(formData.das_pa2)
          ? formData.das_pa2.join("/")
          : "",
        cfe_pa2: Array.isArray(formData.cfe_pa2)
          ? formData.cfe_pa2.join("/")
          : "",
        cvae_pa2: Array.isArray(formData.cvae_pa2)
          ? formData.cvae_pa2.join("/")
          : "",
        is_pa2: Array.isArray(formData.is_pa2) ? formData.is_pa2.join("/") : "",
        //
        //
        cet_pa3: Array.isArray(formData.cet_pa3)
          ? formData.cet_pa3.join("/")
          : "",
        cnil_pa3: Array.isArray(formData.cnil_pa3)
          ? formData.cnil_pa3.join("/")
          : "",
        pdc_pa3: Array.isArray(formData.pdc_pa3)
          ? formData.pdc_pa3.join("/")
          : "",
        cid_pa3: Array.isArray(formData.cid_pa3)
          ? formData.cid_pa3.join("/")
          : "",
        pdr_pa3: Array.isArray(formData.pdr_pa3)
          ? formData.pdr_pa3.join("/")
          : "",
        rdb_pa3: Array.isArray(formData.rdb_pa3)
          ? formData.rdb_pa3.join("/")
          : "",
        cetp_pa3: Array.isArray(formData.cetp_pa3)
          ? formData.cetp_pa3.join("/")
          : "",
        edb_pa3: Array.isArray(formData.edb_pa3)
          ? formData.edb_pa3.join("/")
          : "",
        edr_pa3: Array.isArray(formData.edr_pa3)
          ? formData.edr_pa3.join("/")
          : "",
        cdr_pa3: Array.isArray(formData.cdr_pa3)
          ? formData.cdr_pa3.join("/")
          : "",
        pdl_pa3: Array.isArray(formData.pdl_pa3)
          ? formData.pdl_pa3.join("/")
          : "",
        edl_pa3: Array.isArray(formData.edl_pa3)
          ? formData.edl_pa3.join("/")
          : "",
        pde_pa3: Array.isArray(formData.pde_pa3)
          ? formData.pde_pa3.join("/")
          : "",
        sid_pa3: Array.isArray(formData.sid_pa3)
          ? formData.sid_pa3.join("/")
          : "",
        pdls_pa3: Array.isArray(formData.pdls_pa3)
          ? formData.pdls_pa3.join("/")
          : "",
        pdp_pa3: Array.isArray(formData.pdp_pa3)
          ? formData.pdp_pa3.join("/")
          : "",
        dsn_pa3: Array.isArray(formData.dsn_pa3)
          ? formData.dsn_pa3.join("/")
          : "",
        dac_pa3: Array.isArray(formData.dac_pa3)
          ? formData.dac_pa3.join("/")
          : "",
        dao_pa3: Array.isArray(formData.dao_pa3)
          ? formData.dao_pa3.join("/")
          : "",
        dal_pa3: Array.isArray(formData.dal_pa3)
          ? formData.dal_pa3.join("/")
          : "",
        dalm_pa3: Array.isArray(formData.dalm_pa3)
          ? formData.dalm_pa3.join("/")
          : "",
        daf_pa3: Array.isArray(formData.daf_pa3)
          ? formData.daf_pa3.join("/")
          : "",
        dads_pa3: Array.isArray(formData.dads_pa3)
          ? formData.dads_pa3.join("/")
          : "",
        tdd_pa3: Array.isArray(formData.tdd_pa3)
          ? formData.tdd_pa3.join("/")
          : "",
        ras_pa3: Array.isArray(formData.ras_pa3)
          ? formData.ras_pa3.join("/")
          : "",
        tddi_pa3: Array.isArray(formData.tddi_pa3)
          ? formData.tddi_pa3.join("/")
          : "",
        tdru_pa3: Array.isArray(formData.tdru_pa3)
          ? formData.tdru_pa3.join("/")
          : "",
        tddd_pa3: Array.isArray(formData.tddd_pa3)
          ? formData.tddd_pa3.join("/")
          : "",
        eema_pa3: Array.isArray(formData.eema_pa3)
          ? formData.eema_pa3.join("/")
          : "",
        tdrd_pa3: Array.isArray(formData.tdrd_pa3)
          ? formData.tdrd_pa3.join("/")
          : "",
        tdrm_pa3: Array.isArray(formData.tdrm_pa3)
          ? formData.tdrm_pa3.join("/")
          : "",
        tdrde_pa3: Array.isArray(formData.tdrde_pa3)
          ? formData.tdrde_pa3.join("/")
          : "",
        eetd_pa3: Array.isArray(formData.eetd_pa3)
          ? formData.eetd_pa3.join("/")
          : "",
        mep_pa3: Array.isArray(formData.mep_pa3)
          ? formData.mep_pa3.join("/")
          : "",
        mepe_pa3: Array.isArray(formData.mepe_pa3)
          ? formData.mepe_pa3.join("/")
          : "",
        edld_pa3: Array.isArray(formData.edld_pa3)
          ? formData.edld_pa3.join("/")
          : "",
        ...Object.fromEntries(
          Object.entries(formData).map(([key, value]) => [
            key,
            value === "" ? "[MANQUANT]" : value,
          ])
        ),
        // Garantir que forme_sociale est toujours une valeur non vide pour le
        // template — accepte aussi bien les valeurs de la liste fixe que le
        // texte libre saisi via l'option "Autre" (SelectOuAutre.js).
        forme_sociale:
          typeof formData.forme_sociale === "string" &&
          formData.forme_sociale.trim() !== ""
            ? formData.forme_sociale
            : "EI",
        // Période d'essai non affichée pour I SUITE EXPERT
        periode_essai: formData.tarif !== "I SUITE EXPERT",
        // LM BC RBE.docx est le seul template avec un tag {mail} — c'est
        // volontairement le même champ que "email" (pré-rempli par
        // ClientSearch.js depuis le client/prospect sélectionné), pas un
        // champ de saisie séparé. Sans effet sur les autres LM (tag absent
        // de leur template).
        mail:
          typeof formData.email === "string" && formData.email.trim() !== ""
            ? formData.email
            : "[MANQUANT]",
        // Pied de page juridique du cabinet : toujours recalculé depuis
        // CABINETS_LM en fonction du cabinet sélectionné (lieu_collab) au
        // moment de la génération, plutôt que dépendre des 7 champs
        // formData qui peuvent être vides (brouillon ancien, restauration
        // incomplète...) — lieu_collab est le seul champ obligatoire, donc
        // la seule source fiable pour ce bloc.
        ...(CABINETS_LM[formData.lieu_collab] || {}),
      };

      // LM Audit d'acquisition : titres/lignes du §2.2, bloc d'honoraires
      // fixe ou proportionnel et montants formatés.
      if (selectedForm === LM_AUDIT) {
        Object.assign(updatedFormData, donneesDocumentAudit(formData));
        // Position des signatures calculée selon les lignes cochées
        // (auditSignature.js), transmise via nombreLignesTableau.
        setNombreLignesTableau(codePositionAudit(formData));
        setNombreLignesTexteLibre(0);
      }

      // LM libre – autres prestations : textes saisis, listes de travaux /
      // exclusions, lignes et totaux d'honoraires.
      if (selectedForm === LM_LIBRE) {
        Object.assign(updatedFormData, donneesDocumentLibre(formData));
      }

      const response = await fetch(`/${selectedForm}`);
      if (!response.ok) {
        throw new Error("Erreur lors du chargement du fichier");
      }

      const arrayBuffer = await response.arrayBuffer();
      const zip = new PizZip(arrayBuffer);

      const doc = new Docxtemplater(zip, {
        paragraphLoop: true,
        linebreaks: true,
      });

      doc.render(updatedFormData);
      if (action === ACTIONS.VISUALISE) setLoadingStepIdx(1);

      const output = doc.getZip().generate({ type: "blob" });

      const formDataToSend = new FormData();
      formDataToSend.append("file", output, getFileName(selectedForm));
      if (action === ACTIONS.VISUALISE) setLoadingStepIdx(2);

      // Envoi du fichier à l'API de conversion
      const uploadResponse = await authFetch(
        "https://backend-myalfa.vercel.app/api/upload",
        {
          method: "POST",
          body: formDataToSend,
        }
      );

      // // Envoi du fichier à l'API de conversion
      // const uploadResponse = await authFetch(
      //   "http://localhost:5000/api/upload",
      //   {
      //     method: "POST",
      //     body: formDataToSend,
      //   }
      // );

      // if (!uploadResponse.ok) {
      //   throw new Error("Erreur lors de l'envoi du fichier");
      // }

      // Récupération de l'URL du fichier PDF généré
      const { pdfUrl } = await uploadResponse.json();
      if (action === ACTIONS.VISUALISE) {
        setLoadingStepIdx(3);
        await new Promise((r) => setTimeout(r, 350));
        setLoadingStepIdx(4);
        await new Promise((r) => setTimeout(r, 250));
      }
      setPdfUrl(pdfUrl);
    } catch (error) {
      console.error("Erreur lors de la génération du document:", error);
      dialog.alert("Une erreur est survenue. Détails : " + error.message);
      setLoadingStepIdx(-1);
    } finally {
      setIsLoading(false);
    }
  };

  const getFileName = (selectedForm) => {
    switch (selectedForm) {
      case "LM Globale SCTE.docx":
        return "LM Globale SCTE_modifie.docx";
      case "LM Globale EI.docx":
        return "LM GLOBALE EI_modifie.docx";
      case "LM BNC.docx":
        return "LM BNC.docx_modifie.docx";
      case "LM Création de société.docx":
        return "LM Création de société_modifie.docx";
      case "LM Sécrétariat juridique.docx":
        return "LM Sécrétariat juridique_modifie.docx";
      case "LM Prévisionnel.docx":
        return "LM Prévisionnel_modifie.docx";
      case "LM sociale.docx":
        return "LM sociale_modifie.docx";
      case "LM BG Logiciel.docx":
        return "LM BG Logiciel.docx";
      case "LM social ponctuelle.docx":
        return "LM social ponctuelle.docx";
      case "LM Evaluation.docx":
        return "LM Evaluation.docx";
      case "LM IR.docx":
        return "LM IR.docx";
      case "LM Situation.docx":
        return "LM Situation.docx";
      case "BON DE COMMANDE.docx":
        return "BON DE COMMANDE_modifie.docx";
      case "LM BC RBE.docx":
        return "LM BC RBE_modifie.docx";
      // Sans apostrophe : le nom sert aussi d'URL (stockage + conversion PDF).
      case LM_AUDIT:
        return "LM Audit acquisition_modifie.docx";
      // « LM [nom de la mission] », jamais le nom du modèle.
      case LM_LIBRE:
        return `${nomDocumentLibre(formData)}.docx`;
      default:
        return "Lettre_de_mission_modifie.docx";
    }
  };

  const requiredFieldsByForm = {
    "LM Globale SCTE.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM Globale EI.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM BNC.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM Création de société.docx": [
      "nom_client",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "acticite_principale",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM Sécrétariat juridique.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "expert_comptable",
      "expert_comptable_nom",
      "mois_intervention",
    ],
    "LM micro entreprise.docx": [
      "nom_client",
      "date_creation",
      "lieu_collab",
      "acticite_principale",
      "nom",
      "prenom",
      "email",
      "volumes_annuels",
      "siret",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM Prévisionnel.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "LM sociale.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
      "premiere_dsn",
      "premier_tri_dsn",
    ],
    "LM social ponctuelle.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "expert_comptable",
      "expert_comptable_nom",
      "mois_intervention",
    ],
    "LM Evaluation.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
    ],
    "LM IR.docx": [
      "nom_client",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
    ],
    // La sélection du cabinet est obligatoire sur TOUTES les LM
    "LM BG Logiciel.docx": ["lieu_collab"],
    "LM Situation.docx": [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "siren",
      "acticite_principale",
      "date_debut",
      "date_fin",
      "expert_comptable",
      "expert_comptable_nom",
    ],
    "BON DE COMMANDE.docx": [
      "nom_client",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "telephone",
      "intitule_atelier",
      "date_atelier",
    ],
    "LM BC RBE.docx": ["nom_client", "lieu_collab", "email"],
    [LM_AUDIT]: [
      "nom_client",
      "forme_sociale",
      "lieu_collab",
      "nom",
      "prenom",
      "email",
      "expert_comptable",
      "expert_comptable_nom",
      "mois_intervention",
      "prix_achat",
    ],
    // Mêmes champs que les autres LM (pas de champ obligatoire propre).
    [LM_LIBRE]: ["nom_client", "forme_sociale", "lieu_collab", "nom", "prenom", "email"],
  };

  const fieldLabels = {
    nom_client: "Nom du client",
    forme_sociale: "Forme sociale",
    lieu_collab: "Sélection du cabinet",
    nom: "Nom",
    prenom: "Prénom",
    email: "Email",
    telephone: "Téléphone",
    adresse: "Adresse",
    siren: "SIREN",
    siret: "SIRET",
    acticite_principale: "Activité principale",
    date_debut: "Date de début",
    date_fin: "Date de fin",
    expert_comptable: "Expert comptable",
    expert_comptable_nom: "Nom de l'expert-comptable",
    mois_intervention: "Mois d'intervention",
    intitule_atelier: "Intitulé de l'atelier",
    date_atelier: "Date de l'atelier",
    prix_achat: "Prix d'achat envisagé",
  };

  const validateForm = () => {
    const requiredFields = requiredFieldsByForm[selectedForm] || [];
    const missing = [];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        missing.push(field);
      }
    }

    if (missing.length > 0) {
      setMissingFields(true);
      // Passe le sélecteur de cabinet en "champ requis" (rouge) si c'est lui qui manque
      setCabinetRequisVisible(missing.includes("lieu_collab"));

      const missingLabels = missing.map((field) => fieldLabels[field] || field);

      dialog.alert(
        "Veuillez remplir les champs suivants :\n" + missingLabels.join("\n")
      );

      return false;
    } else {
      setMissingFields(false);
      setCabinetRequisVisible(false);
      return true;
    }
  };

  const handleLMAchveClick = () => {
    setShowLMAcheveOverlay(true);
  };

  useEffect(() => {
    if (showLMAcheveOverlay) {
      setIsLoadingLmNonAcheves(true); // Lancement du chargement

      authFetch("https://backend-myalfa.vercel.app/api/lmnonacheve")
        .then((response) => response.json())
        .then((data) => setLmNonAcheves(data))
        .catch((error) =>
          console.error("Erreur lors de la récupération :", error)
        )
        .finally(() => {
          setIsLoadingLmNonAcheves(false); // Fin du chargement
        });
    }
  }, [showLMAcheveOverlay]);

  const handleDelete = async (id) => {
    try {
      const response = await authFetch(
        `https://backend-myalfa.vercel.app/api/lmnonacheve/${id}`,
        {
          method: "DELETE",
        }
      );

      if (!response.ok) {
        throw new Error("Échec de la suppression");
      }

      // Met à jour la liste localement
      setLmNonAcheves((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
      dialog.alert("Une erreur est survenue lors de la suppression.");
    }
  };

  const handleFillFormData = (item) => {
    // D'abord reset
    handleResetFormData();

    // Puis remplissage après un court délai pour laisser le reset s'appliquer
    setTimeout(() => {
      setFormData((prev) => ({
        ...prev,
        tarif: item.tarif,
        details_tarif: item.details_tarif,
        details_tarif_prix: item.details_tarif_prix,
        details_tarif_prix_tva: item.details_tarif_prix_tva,
        details_tarif_prix_total: item.details_tarif_prix_total,
        tva_taux: item.tva_taux,
        tva_taux_libelle: item.tva_taux_libelle,
        //
        diligences: item.diligences,
        honoraires: item.honoraires,
        abrv: item.abrv,
        selectedForm: item.selectedForm,
        forme_sociale:
          typeof item.forme_sociale === "string" &&
          item.forme_sociale.trim() !== ""
            ? item.forme_sociale
            : "EI",
        nom_client: item.nom_client,
        date_jour: item.date_jour,
        mission_proposer: item.mission_proposer,
        lieu_collab: item.lieu_collab,
        civilite_lm: item.civilite_lm,
        civilite_sign: item.civilite_sign,
        nom: item.nom,
        prenom: item.prenom,
        email: item.email,
        telephone: item.telephone,
        adresse: item.adresse,
        siren: item.siren,
        siret: item.siret,
        acticite_principale: item.acticite_principale,
        date_cloture_jour: item.date_cloture_jour,
        date_cloture_mois: item.date_cloture_mois,
        date_cloture: item.date_cloture,
        effectif: item.effectif,
        organisation_comptable: item.organisation_comptable,
        volumes_annuels: item.volumes_annuels,
        mission_comptables: item.mission_comptables,
        mission_sociale: item.mission_sociale,
        mission_juridique: item.mission_juridique,
        date_creation: item.date_creation,
        date_debut: item.date_debut,
        date_fin: item.date_fin,
        premiere_dsn_raw: item.premiere_dsn_raw,
        premiere_dsn: item.premiere_dsn,
        premier_tri_dsn: item.premier_tri_dsn,
        premier_tri_dsn_raw: item.premier_tri_dsn_raw,
        expert_comptable: item.expert_comptable,
        expert_comptable_nom: item.expert_comptable_nom,
        hono_compta: item.hono_compta,
        hono_compta_bnc: item.hono_compta_bnc,
        hono_compta_me: item.hono_compta_me,
        hono_juridique: item.hono_juridique,
        hono_social: item.hono_social,
        hono_tele: item.hono_tele,
        mission_complementaire: item.mission_complementaire,
        mois_intervention: item.mois_intervention,
        total_honoraires: item.total_honoraires,
        TVA_honoraires_pourcentage: item.TVA_honoraires_pourcentage,
        TVA_honoraires: item.TVA_honoraires,
        total_honoraires_ttc: item.total_honoraires_ttc,
        type_evaluation: item.type_evaluation,
        details_type_evaluation: item.details_type_evaluation,
        champ_libre: item.champ_libre,
        texteFin: item.texteFin,
        declaration_ir: item.declaration_ir,
        declaration_tns: item.declaration_tns,
        declaration_ds: item.declaration_ds,
        declaration_ifi: item.declaration_ifi,
        pr_annee: item.pr_annee,
        hono_ir: item.hono_ir,
        hono_ir_12: item.hono_ir_12,
        avenant: item.avenant,
        numero_avenant: item.numero_avenant,
        date_avenant: item.date_avenant,
        textAvenant: item.textAvenant,
        // Pied de page juridique du cabinet : toujours recalculé depuis
        // CABINETS_LM en fonction de lieu_collab plutôt que restauré tel
        // quel depuis le brouillon — sinon un brouillon enregistré avant
        // l'ajout de ces colonnes (ou toute autre incohérence) restaure un
        // pied de page vide alors que le cabinet, lui, est bien renseigné.
        denomination_cab:
          CABINETS_LM[item.lieu_collab]?.denomination_cab ??
          item.denomination_cab,
        forme_cab: CABINETS_LM[item.lieu_collab]?.forme_cab ?? item.forme_cab,
        capital_cab:
          CABINETS_LM[item.lieu_collab]?.capital_cab ?? item.capital_cab,
        siege_cab: CABINETS_LM[item.lieu_collab]?.siege_cab ?? item.siege_cab,
        siren_cab: CABINETS_LM[item.lieu_collab]?.siren_cab ?? item.siren_cab,
        siret_cab: CABINETS_LM[item.lieu_collab]?.siret_cab ?? item.siret_cab,
        ville_rcs_cab:
          CABINETS_LM[item.lieu_collab]?.ville_rcs_cab ?? item.ville_rcs_cab,
        // LM Audit d'acquisition
        type_remuneration: item.type_remuneration || "fixe",
        motifs_reprise: item.motifs_reprise || "",
        secteur_activite: item.secteur_activite || "",
        cible_acquisition: item.cible_acquisition || "",
        prix_achat: item.prix_achat || "",
        modalite_financement: item.modalite_financement || "",
        calendrier_acquisition: item.calendrier_acquisition || "",
        montant_fixe: item.montant_fixe || "",
        taux_honoraires: item.taux_honoraires || "",
        montant_minimum: item.montant_minimum || "",
        audit_lignes_exclues: item.audit_lignes_exclues || [],
        // LM libre – autres prestations (listes relues depuis le JSON par le formulaire)
        nom_mission: item.nom_mission || "",
        description_mission: item.description_mission || "",
        livrable: item.livrable || "",
        descriptif_mission: item.descriptif_mission || "",
        autres_informations: item.autres_informations || "",
        libre_travaux: item.libre_travaux || [""],
        libre_exclusions: item.libre_exclusions || [""],
        libre_honoraires: item.libre_honoraires || [{ libelle: "", montant: "" }],
      }));
      setSelectedForm(item.selectedForm);
      setItemType(item.itemType);
      // Brouillon repris : les prochains enregistrements le mettent à jour.
      setBrouillonLm({
        id: item.id,
        cle: cleBrouillon(item),
        reference: item.reference,
      });
      setShowLMAcheveOverlay(false);
    }, 0); // ou 50ms si jamais tu as un souci de synchro
  };

  const formWithoutExtension =
    selectedForm === LM_LIBRE
      ? LIBELLE_LM_LIBRE
      : selectedForm.endsWith(".docx")
      ? selectedForm.slice(0, -5)
      : selectedForm;

  const completionSteps = [
    {
      key: "modele",
      label: "Modèle sélectionné",
      completed: formWithoutExtension !== " ",
    },
    {
      key: "client",
      label:
        itemType === "client"
          ? "Client sélectionné"
          : itemType === "annuaire"
          ? "Annuaire sélectionné"
          : "Prospect sélectionné",
      completed: formData.nom !== " " || formData.nom_client !== " ",
    },
    {
      key: "mission",
      label: "Détails mission",
      completed: detailsMission === true, // condition à ajouter plus tard
    },
    {
      key: "honoraires",
      label: "Honoraires définis",
      completed: detailsHonoraire === true, // condition à ajouter plus tard
    },
  ];

  const completedCount = completionSteps.filter(
    (step) => step.completed
  ).length;
  const completionPercentage = (completedCount / completionSteps.length) * 100;

  return (
    <>
      <div
        style={{
          margin: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "98%",
          padding: "10px 0",
        }}
      >
        {" "}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#8B1D41] to-[#6B1731] flex items-center justify-center">
            <FileText size={20} color="white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-800">
              Lettre de Mission
            </h1>
            <p className="text-sm text-slate-500">
              Génération simplifiée en un seul écran
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-xl px-3 py-2 shadow-sm">
            <Calendar className="w-4 h-4 text-slate-400 shrink-0" />
            <div>
              <p className="text-[10px] text-slate-400 leading-none mb-0.5">La LM sera créée le</p>
              <input
                type="date"
                value={formData.date_jour ? formData.date_jour.split("/").reverse().join("-") : ""}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val) setFormData((prev) => ({ ...prev, date_jour: val.split("-").reverse().join("/") }));
                }}
                className="text-sm font-semibold text-slate-800 outline-none bg-transparent border-none cursor-pointer"
              />
            </div>
          </div>
          <button
            type="button"
            onClick={handleLMAchveClick}
            title="Lettres de mission débutées"
            className="flex items-center gap-2 h-10 px-3 rounded-xl bg-white border border-slate-200 text-sm font-medium text-slate-600 hover:bg-slate-50 hover:text-[#840040] hover:border-[#840040]/30 transition-colors shadow-sm"
          >
            <CiViewList size={18} />
            Brouillons
          </button>
        </div>
      </div>
      <div className="ContainerSignModif">
        <div className="SignModif">
          <div
            style={{
              margin: 0,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              padding: "10px 0",
            }}
          >
            <div className="mb-3" style={{ marginBottom: "15px" }}>
              <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wide mb-1">
                Modèle de document
              </h2>
              <p className="text-xs text-slate-500">
                Sélectionnez le type de lettre de mission à générer
              </p>
            </div>
            <button
              onClick={handleResetFormData}
              className="w-full h-10 text-sm border-slate-20 hover:bg-slate-50 bg-white "
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "5px 15px",
                width: "fit-content",
              }}
            >
              <IoReload size={12} />
              Réinitialiser le formulaire
            </button>
          </div>
          <LetterSelect
            className="w-full max-w-2xl z-5"
            selectedForm={selectedForm}
            handleFormChange={handleFormChange}
            disabled={false} // ou selon ton état
          />
          <br />
          <div className="mb-3" style={{ marginBottom: "15px" }}>
            <h2 className="text-sm font-semibold text-slate-700 uppercase tracking-wide mb-1">
              {selectedForm === "LM IR.docx"
                ? "Annuaire "
                : "Client / Prospect"}
            </h2>
            <p className="text-xs text-slate-500">
              Recherchez et sélectionnez le client concerné
            </p>
          </div>
          <ClientSearch
            setFormData={setFormData}
            setSelectedClientId={setSelectedClientId}
            setSelectedLeadId={setSelectedLeadId}
            setItemType={setItemType}
            initialClientId={clientIdGlobal}
          />
          {/* {detailsMission && <p> details mission true</p>}{" "}
          {!detailsMission && <p> details mission false</p>} */}
          <br />
          {selectedForm === "LM Globale SCTE.docx" && (
            <LMGSCTEForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              requiredFields={requiredFieldsByForm["LM Globale SCTE.docx"]}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM Globale EI.docx" && (
            <LMEIGlobaleForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM BNC.docx" && (
            <LMBNCForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              handleCheckboxChangeDevis={handleCheckboxChangeDevis}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM Création de société.docx" && (
            <LMCREATIONForm
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              handleCheckboxChangeDevis={handleCheckboxChangeDevis}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
              onHonoraireChange={onHonoraireChange}
            />
          )}
          {selectedForm === "LM Sécrétariat juridique.docx" && (
            <LMSECRETARIATForm
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM micro entreprise.docx" && (
            <LMME
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM Prévisionnel.docx" && (
            <LMPREVForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM sociale.docx" && (
            <LMSocialForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM BG Logiciel.docx" && (
            <LMLogiciel
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM social ponctuelle.docx" && (
            <LMSOCIALPONCTForm
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM Evaluation.docx" && (
            <LMEVALUATIONForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM IR.docx" && (
            <LMIRForm
              handleHonoChange={handleHonoChange}
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChange={handleCheckboxChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM Situation.docx" && (
            <LMSITUATIONForm
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "BON DE COMMANDE.docx" && (
            <LMBDCForm
              handleInputChange={handleInputChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === "LM BC RBE.docx" && (
            <LMBCRBEForm
              handleInputChange={handleInputChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === LM_AUDIT && (
            <LMAUDITForm
              handleInputChange={handleInputChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {selectedForm === LM_LIBRE && (
            <LMLIBREForm
              handleInputChange={handleInputChange}
              handleDateClotureChange={handleDateClotureChange}
              setDetailsMission={setDetailsMission}
              setDetailsHonoraire={setDetailsHonoraire}
            />
          )}
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "3%",
            }}
          >
            <button
              type="button"
              className="ModifLM"
              onClick={handleSaveLM}
              disabled={loadingLMSaved}
            >
              {loadingLMSaved
                ? "Enregistrement en cours..."
                : "Enregistrer le brouillon"}
            </button>
            <button
              className="Modif"
              onClick={() => {
                if (validateForm()) {
                  setShouldNavigate(true);
                  generateDocument();
                  generateDocument(ACTIONS.VISUALISE);
                }
              }}
            >
              {isLoading ? "Conversion en cours..." : "Convertir et soumettre"}
            </button>
          </div> */}
          <br />
          <br />
        </div>
        <div className="PreviewSignModif bg-white ">
          <div
            className="bg-gradient-to-r from-[#8B1D41] to-[#6B1731] text-white p-4 "
            style={{
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <div className="text-base font-semibold flex items-center gap-2">
              <FileText size={20} />
              <p>Récapitulatif & Finalisation</p>
            </div>
          </div>
          <br />
          <div style={{ padding: "0 15px" }} className="bg-white">
            {/* Progression des étapes */}
            <div className="space-y-3 mb-6">
              {/* Header */}
              <div className="flex items-center justify-between text-xs">
                <span className="text-slate-500">Complété</span>
                <span
                  className={`font-semibold ${
                    completedCount === completionSteps.length
                      ? "text-emerald-600"
                      : "text-slate-500"
                  }`}
                >
                  {completedCount}/{completionSteps.length}
                </span>
              </div>

              {/* Progress bar */}
              <div className="w-full h-1 bg-slate-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-emerald-500 transition-all duration-300"
                  style={{ width: `${completionPercentage}%` }}
                />
              </div>

              {/* Checklist */}
              <div className="space-y-1.5">
                {completionSteps.map((step) => (
                  <div
                    key={step.key}
                    className="flex items-center gap-2 text-xs"
                  >
                    <div
                      className={`w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 ${
                        step.completed ? "bg-emerald-500" : "bg-slate-200"
                      }`}
                    >
                      {step.completed && (
                        <svg
                          className="w-2.5 h-2.5 text-white"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="3"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M5 13l4 4L19 7"
                          />
                        </svg>
                      )}
                    </div>

                    <span
                      className={
                        step.completed ? "text-slate-700" : "text-slate-400"
                      }
                    >
                      {step.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {formData.selectedForm !== " " && (
              <div className="space-y-1" style={{ marginBottom: "20px" }}>
                <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold">
                  Modèle
                </p>
                <div className="p-2 bg-slate-50 rounded-lg">
                  <p className="text-sm font-semibold text-slate-800">
                    {formWithoutExtension}
                  </p>
                  <p className="text-xs text-slate-500">Lettre de Mission</p>
                </div>
              </div>
            )}
            {(formData.nom !== " " || formData.nom_client !== " ") && (
              <div className="space-y-1">
                <p className="text-xs text-slate-500 uppercase tracking-wide font-semibold">
                  {itemType === "client"
                    ? "Client"
                    : itemType === "annuaire"
                    ? "Annuaire"
                    : "Prospect"}
                </p>
                <div className="p-2 bg-slate-50 rounded-lg">
                  <p className="text-sm font-semibold text-slate-800">
                    {itemType === "client"
                      ? `${formData.nom_client}`
                      : `${formData.nom} ${formData.prenom}`}
                  </p>
                  <div className="flex items-center gap-2 mt-1">
                    <div
                      variant="secondary"
                      style={{
                        fontSize: "10px",
                        padding: "2px 6px",
                        borderRadius: "6px",
                        background:
                          itemType === "client"
                            ? "#d1fae5"
                            : itemType === "annuaire"
                            ? "#dbeafe"
                            : "#fef08a",
                        color:
                          itemType === "client"
                            ? "#065f46"
                            : itemType === "annuaire"
                            ? "#1d4ed8"
                            : "#b91c1c",
                      }}
                    >
                      {itemType === "client"
                        ? "Client"
                        : itemType === "annuaire"
                        ? "Annuaire"
                        : "Prospect"}
                    </div>
                    {itemType === "client" && (
                      <span className="text-xs text-slate-500">
                        {formData.nom} {formData.prenom}
                      </span>
                    )}
                    {itemType !== "client" && (
                      <span className="text-xs text-slate-500">
                        {itemType === "annuaire"
                          ? formData.nom_client
                          : formData.email}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* // section manquante */}
            {missingFields && (
              <>
                <hr style={{ margin: "20px 0" }} />
                <div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg"
                >
                  <IoAlertCircleOutline className="w-4 h-4 text-amber-600 flex-shrink-0 mt-0.5" />
                  <div className="text-xs text-amber-800">
                    <p className="font-semibold mb-1">Information manquante</p>
                    <p>
                      Complétez tous les champs requis pour générer le document.
                    </p>
                  </div>
                </div>
              </>
            )}
            <hr style={{ margin: "20px 0" }} />
            <div className="space-y-2">
              <button
                type="button"
                onClick={handleSaveLM}
                disabled={loadingLMSaved}
                className="w-full h-10 text-sm border-slate-200 hover:bg-slate-50"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "3px",
                  border: "1px solid #eee",
                  borderRadius: "12px",
                }}
              >
                <LuSave className="w-4 h-4 mr-2" size={20} />
                {loadingLMSaved
                  ? "Enregistrement en cours..."
                  : "Enregistrer le brouillon"}
              </button>
              <button
                onClick={() => {
                  if (validateForm()) {
                    setShouldNavigate(true);
                    generateDocument();
                    generateDocument(ACTIONS.VISUALISE);
                  }
                }}
                disabled={isLoading}
                className="w-full h-10 text-sm border-slate-200 hover:bg-slate-50 disabled:opacity-60 disabled:cursor-not-allowed"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "3px",
                  border: "1px solid #eee",
                  borderRadius: "12px",
                }}
              >
                <FileText className="w-4 h-4 mr-2" size={20} />
                {isLoading
                  ? "Traitement en cours..."
                  : "Visualiser et soumettre / signer"}
              </button>
              {isLoading && loadingStepIdx >= 0 && (
                <div className="mt-3 px-1">
                  <div className="space-y-1.5 mb-3">
                    {LOADING_STEPS.map((step, i) => (
                      <div
                        key={i}
                        className="flex items-center gap-2 text-xs transition-all duration-300"
                        style={{
                          color:
                            i < loadingStepIdx
                              ? "#10b981"
                              : i === loadingStepIdx
                              ? "#840040"
                              : "#cbd5e1",
                          fontWeight: i === loadingStepIdx ? "500" : "400",
                        }}
                      >
                        <div
                          className="w-3.5 h-3.5 rounded-full flex-shrink-0 flex items-center justify-center transition-all duration-300"
                          style={{
                            background:
                              i < loadingStepIdx
                                ? "#10b981"
                                : i === loadingStepIdx
                                ? "#840040"
                                : "#e2e8f0",
                          }}
                        >
                          {i < loadingStepIdx && (
                            <svg
                              className="w-2 h-2"
                              style={{ color: "white" }}
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="3"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          )}
                          {i === loadingStepIdx && (
                            <div
                              className="w-1.5 h-1.5 rounded-full animate-ping"
                              style={{ background: "white" }}
                            />
                          )}
                        </div>
                        <span>{step.label}</span>
                      </div>
                    ))}
                  </div>
                  <div
                    className="w-full rounded-full overflow-hidden"
                    style={{ height: "3px", background: "#f1f5f9" }}
                  >
                    <div
                      className="h-full rounded-full transition-all duration-700"
                      style={{
                        width: `${
                          loadingStepIdx >= 0
                            ? Math.round(
                                (loadingStepIdx / (LOADING_STEPS.length - 1)) *
                                  100
                              )
                            : 0
                        }%`,
                        background:
                          "linear-gradient(to right, #840040, #9B1B5D)",
                      }}
                    />
                  </div>
                  <p
                    className="text-center mt-1.5 transition-all duration-300"
                    style={{ fontSize: "10px", color: "#94a3b8" }}
                  >
                    {LOADING_STEPS[loadingStepIdx]?.sublabel}
                  </p>
                </div>
              )}
            </div>
            <div
              className="flex items-center justify-center gap-2 text-xs text-slate-400"
              style={{ marginTop: "15px" }}
            >
              <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse" />
              <span>Enregistrement automatique</span>
            </div>
          </div>
        </div>

        {showLMAcheveOverlay && (
          <div
            className="fixed inset-0 bg-black/50 z-[1000] flex items-center justify-center p-4"
            onClick={() => setShowLMAcheveOverlay(false)}
          >
            <div
              className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-hidden flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-slate-100">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-[#8B1D41] to-[#6B1731] flex items-center justify-center flex-shrink-0">
                    <CiViewList size={18} color="white" />
                  </div>
                  <div>
                    <h2 className="text-base font-bold text-slate-800 leading-tight m-0">
                      Lettres de mission débutées
                    </h2>
                    <p className="text-xs text-slate-500 m-0 mt-0.5">
                      Reprenez ou supprimez un brouillon
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setShowLMAcheveOverlay(false)}
                  className="w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center text-slate-400 hover:text-slate-700 transition-colors flex-shrink-0"
                >
                  <X size={16} />
                </button>
              </div>

              {/* Corps */}
              <div className="overflow-y-auto flex-1 px-6 py-4">
                {isLoadingLmNonAcheves ? (
                  <div className="space-y-2">
                    {Array.from({ length: 4 }).map((_, i) => (
                      <div
                        key={i}
                        className="flex items-center justify-between p-3 rounded-xl border border-slate-100 animate-pulse"
                      >
                        <div className="space-y-2">
                          <div className="h-3 w-40 bg-slate-200 rounded" />
                          <div className="h-2.5 w-28 bg-slate-100 rounded" />
                          <div className="h-2.5 w-48 bg-slate-100 rounded" />
                        </div>
                        <div className="flex gap-2">
                          <div className="w-8 h-8 rounded-full bg-slate-100" />
                          <div className="w-8 h-8 rounded-full bg-slate-100" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : lmNonAcheves.length === 0 ? (
                  <div className="py-10 text-center text-sm text-slate-400">
                    Aucune lettre de mission débutée pour le moment.
                  </div>
                ) : (
                  <div className="space-y-2">
                    {[...lmNonAcheves]
                      .sort(
                        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                      )
                      .map((item) => (
                        <div
                          key={item.id}
                          className="flex items-center justify-between gap-3 p-3 rounded-xl border border-slate-100 hover:border-slate-200 hover:bg-slate-50/50 transition-colors"
                        >
                          <div className="min-w-0">
                            <p className="text-sm font-semibold text-slate-800 m-0 truncate">
                              {item.civilite_lm} {item.prenom} {item.nom}
                            </p>
                            <p className="text-xs text-slate-500 m-0 mt-0.5 truncate">
                              {/* LM libre : « LM [nom de la mission] » pour distinguer les missions */}
                              {item.selectedForm === LM_LIBRE ? nomDocumentLibre(item) : item.selectedForm}
                            </p>
                            <p className="text-xs text-slate-400 m-0 mt-0.5 truncate">
                              {item.email} · {item.telephone}
                            </p>
                            <p className="text-[11px] text-slate-400 m-0 mt-0.5">
                              {new Date(item.createdAt).toLocaleString()}
                            </p>
                          </div>

                          <div className="flex items-center gap-1.5 flex-shrink-0">
                            <button
                              type="button"
                              onClick={() => handleFillFormData(item)}
                              title="Reprendre ce brouillon"
                              className="w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center text-[#840040] hover:bg-[#840040]/5 hover:border-[#840040]/30 transition-colors"
                            >
                              <IoReload size={15} />
                            </button>
                            <button
                              type="button"
                              onClick={() => handleDelete(item.id)}
                              title="Supprimer ce brouillon"
                              className="w-8 h-8 rounded-full border border-slate-200 flex items-center justify-center text-red-500 hover:bg-red-50 hover:border-red-200 transition-colors"
                            >
                              <MdDeleteOutline size={15} />
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default SignModif;
